<template>
  <a href="#" @click.prevent="onClick">
    <img :src="imageUrl" alt="">
    <p style="font-size: 1.3em;">
        Boka möte
    </p>
  </a>
</template>

<style lang="scss" scoped>
  a {
    display: block;
    width: 100%;

    img {
      width: 100%;
      height: auto;
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    p {
      margin-top: 8px;
      margin-bottom: 0px;
      text-align: center;
      text-decoration: none;
      color: black;
    }
  }
</style>

<script setup lang="ts">
interface Props {
    schedulingUrl: string;
    imageUrl: string;
}

const props = defineProps<Props>();

function onClick(): void {
    window.Calendly.showPopupWidget(props.schedulingUrl);
}
</script>
